module.exports = __webpack_public_path__ + "static/media/illustration.6cc3cbc4.svg";